import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function Counter({ to, suffix = "", duration = 1.8 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const target = parseFloat(to);
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / (duration * 1000));
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(target * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {Math.round(val).toLocaleString()}
      {suffix}
    </span>
  );
}

export default function Counters() {
  const stats = [
    { num: 500, suffix: "+", label: "Homes Cleaned" },
    { num: 120, suffix: "+", label: "Offices Serviced" },
    { num: 98, suffix: "%", label: "Repeat Clients" },
    { num: 24, suffix: "/7", label: "Booking Window" },
  ];
  return (
    <section data-testid="counters" className="bg-white py-16 md:py-20">
      <div className="pc-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-2 gap-8 border-y border-black/10 py-10 md:grid-cols-4"
        >
          {stats.map((s) => (
            <div key={s.label} data-testid={`counter-${s.label.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="font-display text-5xl font-black tracking-tighter md:text-6xl">
                <Counter to={s.num} suffix={s.suffix} />
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em] text-black/60">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
